import { render, staticRenderFns } from "./BenefitPartner.vue?vue&type=template&id=3f34e667"
import script from "./BenefitPartner.vue?vue&type=script&lang=js"
export * from "./BenefitPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports